import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import {SMCCheckbox} from '../../Simple/SMCCheckbox';

function SMCTableCheckAll({
    hasCheckAll,
    onChange,
    isChecked,
    className
}) {
    const classes = useStyles();

    return (
        <td className={clsx(classes.checkboxCell, className)}>
            {hasCheckAll && <SMCCheckbox inline className={classes.checkbox} checked={isChecked} onChange={onChange}/>}
        </td>
    );
}

const useStyles = makeStyles({
    checkboxCell: {
        width: '32px',
        minWidth: '32px',
        textAlign: 'center',
        borderLeft: 'none !important'
    },
    checkbox: {
        margin: 0
    }
})

SMCTableCheckAll.propTypes = {
    hasCheckAll: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string
}

export default SMCTableCheckAll;